import React from 'react';
import styled from 'styled-components';
import {
  BaseBox,
  FlexBox,
  Heading3,
  Heading4,
  ellipsis,
  Icons,
} from '@docon/docon-ui-library';
import Image from 'shared/Image';
import { borderColor, colors } from 'utilities/colorConfig';

const Root = styled(FlexBox)`
  padding: 1rem 1rem 0.8rem;
  gap: 0.9rem;
  font-weight: 500;
  ${ellipsis};

  ${Image} {
    border-radius: 50%;
    object-fit: cover;
  }

  ${BaseBox} {
    ${ellipsis};
  }
`;

function DocItem({
  className,
  showRightArrow,
  hidePic,
  picSize = '56px',
  rank = 1,
  subTitle = '',
  doctor: {
    shortUrl = '',
    doctorID = '',
    firstName = '',
    lastName = '',
    thumbnailUrl: { url = '' } = {},
    specialityID = {},
    speciality = '',
    specialityDisplayName = '',
  } = {},
  onClick,
  ...props
}: any) {

  function handleClick() {
    if (onClick)
      onClick({ shortUrl, doctorID, rank });
  }

  return (
    <Root className={`${className} ${onClick ? 'clickable' : ''}`} onClick={handleClick} {...props}>
      <Image
        hidden={hidePic}
        ignoreAssetsPath={url ? true : false}
        src={url || '/images/doctor4@3.svg'}
        size={picSize}
      />
      <BaseBox flex={1}>
        <Heading3 title={`Dr. ${firstName || ''} ${lastName || ''}`} />
        <Heading4 title={subTitle || specialityDisplayName || specialityID?.name || speciality} color={`${colors.secondaryColor}`} />
      </BaseBox>

      {
        showRightArrow ? (
          <Icons.ChevronIcon
            type='right'
            width={20}
            ml='auto'
            alignSelf={'center'}
            color={borderColor}
          />
        ) : null
      }
    </Root>
  );
}

export default styled(DocItem)``;

